import React from "react";
import { Helmet } from 'react-helmet';
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import Section from "../Section";
import WelcomeSection from "../AboutNew/WelcomeSection";
import AwardsSection from "../AboutNew/AwardsSection";
import ExpertProfileSection from "../AboutNew/ExpertProfileSection";
import ServicesSection from "../AboutNew/ServicesSection";
import GallerySection from "../Section/GallerySection";
import { pageTitle } from "../../helpers/PageTitle";


const departmentData = [
  {
    title: "Comprehensive Fertility Diagnostics",
    subTitle:
      "Routine Blood Test, Complete Hormonal Profile (FSH, LH, PRL, T3/T4/TSH, AMH, Estradiol, Testosterone), HSG, Transvaginal & Abdominal Ultrasound, Semen Analysis, Diagnostic Laparoscopy & Hysteroscopy",
    // "Routine Blood Test. Complete Hormonal Profile FSH, LH, PRL, T3T4T5H, Amn, Estradiol, Testostorane etc. Hysterosalpingography (HSG). Transvaginal & Abdominal Ultrasound. Semen Analysis, Diagnostic Laparoscopy, & Hysteroscopy",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // /departments/department-details
  },
  {
    title: "Fertility-Enhancing Endoscopic Surgeries",
    subTitle:
      "Advanced Laparoscopic & Hysteroscopic Surgeries for Fibroids, Septum, Endometriosis, etc.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "Counselling",
    subTitle:
      "Extensive counseling of couples to individualize their treatment and assist in decision-making.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  {
    title: "High-Risk Pregnancy Management",
    subTitle: "We provide comprehensive care to high-risk pregnant patients.",
    iconUrl: "/images/icons/calendar_white.svg",
    href: "#",
    // href: "/departments/department-details",
  },
  // {
  //   title: "Mental health services",
  //   subTitle:
  //     "Counseling, therapy, and other services to help patients manage mental health conditions",
  //   iconUrl: "/images/icons/calendar_white.svg",
  //   href: "#",
  //   // href: "/departments/department-details",
  // },
];
const featureListData = [
  {
    title: "Dr. Archana Shrivastava",
    subTitle: `Welcome to Pluro Jabalpur Fertility Center, situated in Jabalpur, Madhya Pradesh, where under the expert leadership of Dr. Archana Shrivastava, we offer a comprehensive suite of advanced fertility treatments, including IVF, ICSI, IUI, Hysteroscopy, and Laparoscopy, as well as specialized services such as Embryo, Egg, and Sperm Donation, all within our state-of-the-art facility designed to provide an exceptional healthcare experience, demonstrating our unwavering commitment to addressing and resolving a wide range of fertility challenges with the utmost effectiveness and compassionate care, earning the trust and confidence of our valued patients.`,
    iconUrl: "/images/icons/professional.svg",
  },
];
const teamData = [
  {
    imgUrl: "/images/about/Dr.Archana.JPG",
    name: "Dr. Archana Shrivastava",
    designation: "MBBS , DGO",
    description:
      "Dr. Archana Shrivastava has 24 years of experience in Obstetrics, Gynecology, and Laparoscopy, specializing in fertility treatment and advanced laparoscopic surgeries.",
    social: [
      {
        icon: "fa6-brands:facebook-f",
        href: "https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre",
      },
      {
        icon: "fa6-brands:instagram",
        href: "https://www.instagram.com/plurojabalpur_ivf/",
      },
      {
        icon: "fa6-brands:youtube",
        href: "https://www.youtube.com/@PluroJabalpur_IVF",
      },
    ],
  },
];
const galleryData = [
  { imgUrl: "/images/about/IMG_3267.webp", alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/about/IMG_3115.webp", alt: "Fertility specialist in mp" },
  { imgUrl: "/images/about/IMG_3045.webp", alt: "Oligospermia treatment in mp" },
  { imgUrl: "/images/gallary/about_gallry2.webp", tag: "Comfort", title: "Relaxed Environment", tagColor: "orange", span: 1, alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/about/IMG_2975.webp", alt: "Best fertility hospital in mp" },
  { imgUrl: "/images/about/IMG_3181.webp", alt: "Best IVF doctor in mp" },
  { imgUrl: "/images/about/IMG_3206.webp", alt: "Best IVF clinic in mp" },
  { imgUrl: "/images/gallary/IMG_3117.webp", tag: "Facilities", title: "State-of-the-Art Laboratory", tagColor: "orange", span: 1, alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/gallary/about_gallary.webp", tag: "Expertise", title: "Compassionate Care", tagColor: "purple", span: 1, alt: "Best IVF clinic in mp" },
  { imgUrl: "/images/about/IMG_2986.webp", alt: "Infertility doctor in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7767.webp", alt: "Egg freezing in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7867.webp", alt: "Best Gynecologist In mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7861.webp", alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7765.webp", alt: "Best IVF clinic in mp" },
  { imgUrl: "/images/gallary/DSC04427.webp", tag: "Care", title: "Our Commitment", tagColor: "orange", span: 1, alt: "Best fertility hospital in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7773.webp", alt: "Fertility specialist in mp" },
];
const awardData = [
  {
    iconUrl: "/images/icons/award.svg",
    title: "Recipient of the ISAR Rising Star Award in February 2024.",
  },
  {
    iconUrl: "/images/icons/award.svg",
    title:
      "Member of the European Society of Human Reproduction and Embryology (ESHRE).",
  },
  {
    iconUrl: "/images/icons/award.svg",
    title:
      "Past Secretary of the Indian Medical Association, Jabalpur Chapter.",
  },
  {
    iconUrl: "/images/icons/award.svg",
    title:
      "Past Vice President of the Jabalpur Obstetrics and Gynaecological Society.",
  },
];

export default function About() {
  pageTitle("About");
  return (
    <>
      <Helmet>
        <title>About Us | Dr. Archana Shrivastava's Pluro Jabalpur Fertility Center</title>
        <meta
          name="description"
          content="Welcome to Pluro Jabalpur Fertility Center, offering advanced fertility treatments like IVF and compassionate care under Dr. Archana Shrivastava's expert leadership."
        />
        <link rel="canonical" href="https://jabalpurivfcentre.com/about" />
      </Helmet>
      <BannerSectionStyle3
        bgUrl="/images/about.jpeg"
        // imgUrl="/images/about/banner_img.png"
        title="Welcome to <br />Pluro Jabalpur <br />Fertility Center"
        subTitle="Unlock Your IVF Journey: Experience Wellness, Hope, and Success with Us!"
      />

      <WelcomeSection
        sectionTitle="About Pluro Jabalpur Fertility Center"
        videoUrl="/videos/ivf.mp4"
        data={ featureListData }
      />

      <ServicesSection
        sectionTitle="Provides Our Best Services"
        sectionTitleUp="SERVICES"
        data={ departmentData }
      />

      <ExpertProfileSection
        sectionTitle="Expert Doctor"
        sectionTitleUp="MEET OUR"
        data={ teamData }
      />

      <AwardsSection
        sectionTitle="Winning Awards and <br />Recognition"
        sectionTitleUp="AWARDS"
        sectionSubTitle="We have been recognized for our commitment to <br />excellence in healthcare."
        data={ awardData }
      />

      <Section
        topMd={ 170 }
        topLg={ 10 }
        topXl={ 80 }
        bottomMd={ 200 }
        bottomLg={ 150 }
        bottomXl={ 110 }
      >
        <GallerySection
          sectionTitle="Our Facilities and <br />Latest Activities"
          sectionTitleUp="HAVE A LOOK AT"
          data={ galleryData }
        />
      </Section>
    </>
  );
}
